export default "__VITE_ASSET__DFstyqnF__"